import { takeLatest, call, put, select } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { api } from "../api";
import { getBaseUrlParams } from "../../../../utils/getBaseUrlParams";
import { showToast } from "../../../../utils/showToast";

export const SET_LOADING = "saga/referralCategories/SET_LOADING";

export const FETCH_REFERRAL_CATEGORIES_SUCCESS =
  "saga/referralCategories/FETCH_REFERRAL_CATEGORIES_SUCCESS";

export const FETCH_ACTIONS = "saga/referralCategories/FETCH_ACTIONS";

export const FETCH_REFERRAL_CATEGORY = "saga/referralCategories/FETCH_REFERRAL_CATEGORY";
export const FETCH_REFERRAL_CATEGORY_SUCCESS =
  "saga/referralCategories/FETCH_REFERRAL_CATEGORY_SUCCESS";

export const FETCH_UNASSIGNED_KEYWORDS = "saga/referralCategories/FETCH_UNASSIGNED_KEYWORDS";

export const ASSIGN_KEYWORDS = "saga/referralCategories/ASSIGN_KEYWORDS";
export const ASSIGN_KEYWORDS_SUCCESS = "saga/referralCategories/ASSIGN_KEYWORDS_SUCCESS";

export const UNASSIGN_KEYWORD = "saga/referralCategories/UNASSIGN_KEYWORD";
export const UNASSIGN_KEYWORD_SUCCESS = "saga/referralCategories/UNASSIGN_KEYWORD_SUCCESS";

export const UNASSIGN_ALL_KEYWORDS = "saga/referralCategories/UNASSIGN_ALL_KEYWORDS";
export const UNASSIGN_ALL_KEYWORDS_SUCCESS =
  "saga/referralCategories/UNASSIGN_ALL_KEYWORDS_SUCCESS";

export const FETCH_CURRENT_USER = "saga/referralCategories/FETCH_CURRENT_USER";

export const RESET_CURRENT_REFERRAL_INFO = "saga/referralCategories/RESET_CURRENT_REFERRAL_INFO";
export const SET_ERROR = "saga/referralCategories/SET_ERROR";
export const SET_STATUS = "saga/referralCategories/SET_STATUS";
export const RESET_STATUS = "saga/referralCategories/RESET_STATUS";

export const RECALCULATE = "saga/referralCategories/RECALCULATE";
export const EXPORT = "saga/referralCategories/EXPORT";

const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  getReferralCategoryInfo: createAction(FETCH_REFERRAL_CATEGORY),
  assignKeywords: createAction(ASSIGN_KEYWORDS),
  unassignKeyword: createAction(UNASSIGN_KEYWORD),
  unassignAllKeywords: createAction(UNASSIGN_ALL_KEYWORDS),
  resetReferralInfo: createAction(RESET_CURRENT_REFERRAL_INFO),
  resetFilters: createAction(RESET_STATUS),
  recalculate: createAction(RECALCULATE),
  exportReferrals: createAction(EXPORT)
};

export const {
  fetchCurrentUser,
  getReferralCategoryInfo,
  deleteRegion,
  assignKeywords,
  unassignKeyword,
  unassignAllKeywords,
  resetReferralInfo,
  recalculate,
  exportReferrals,
  upload
} = actionCreators;

export default function* watchReferralCategories() {
  yield takeLatestSafe(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatestSafe(FETCH_REFERRAL_CATEGORY, fetchReferralCategory);
  yield takeLatestSafe(ASSIGN_KEYWORDS, addKeywords);
  yield takeLatestSafe(UNASSIGN_KEYWORD, removeKeyword);
  yield takeLatestSafe(UNASSIGN_ALL_KEYWORDS, removeAllKeywords);
  yield takeLatestSafe(RECALCULATE, recalculateValues);
  yield takeLatestSafe(EXPORT, exportReferralValues);
}

function takeLatestSafe(action, effect) {
  return takeLatest(action, tryCatch(effect));
}

function tryCatch(effect) {
  return function* (args) {
    try {
      yield call(effect, args);
    } catch (err) {
      console.error(err);
      if (err.response.status === 422) {
        yield put({ type: SET_ERROR, payload: err.response.data });
      }
    }
  };
}

function* getCurrentUserData() {
  yield put({ type: SET_LOADING, payload: true });

  yield fetchReferralCategories();
  yield fetchUnassignedKeywords();
  yield fetchActions();

  yield put({ type: SET_LOADING, payload: false });
}

function* fetchReferralCategories() {
  const { organization_id } = getBaseUrlParams();

  const { data } = yield call(api.getReferralCategories, { params: { organization_id } });

  yield put({
    type: FETCH_REFERRAL_CATEGORIES_SUCCESS,
    payload: data
  });
}

function* fetchActions() {
  const { short_url } = getBaseUrlParams();

  const { data } = yield call(api.getActions, { params: { short_url } });

  yield put({
    type: FETCH_ACTIONS,
    payload: data
  });
}

function* recalculateValues() {
  const { organization_id } = getBaseUrlParams();

  try {
    let res = yield call(api.recalculateReferralCategories, {
      organization_id
    });

    if (res.status == 200) {
      showToast(res.data.message);
    }
  } catch (err) {
    console.log(err);
    showToast(err.response.data.error);
  }
}

function* exportReferralValues() {
  const { organization_id } = getBaseUrlParams();

  try {
    let res = yield call(api.exportReferralCategories, {
      params: {
        organization_id
      }
    });

    if (res.status == 200) {
      showToast(res.data.message);
    }
  } catch (err) {
    console.log(err);
    showToast(err.response.data.error);
  }
}

function* fetchUnassignedKeywords() {
  const { organization_id } = getBaseUrlParams();

  const { data } = yield call(api.getUnassignedKeywords, { params: { organization_id } });

  yield put({
    type: FETCH_UNASSIGNED_KEYWORDS,
    payload: data
  });
}

function* fetchReferralCategory({ payload: { id, keywordsCount, clientsCount } }) {
  yield put({
    type: RESET_CURRENT_REFERRAL_INFO
  });

  if (keywordsCount == 0 && clientsCount == 0) {
    yield put({
      type: FETCH_REFERRAL_CATEGORY_SUCCESS,
      payload: { id, data: [] }
    });
    return;
  }

  const { organization_id } = getBaseUrlParams();

  const { data } = yield call(api.getReferralCategory, id, {
    params: { organization_id }
  });

  yield put({
    type: FETCH_REFERRAL_CATEGORY_SUCCESS,
    payload: { id, data }
  });
}

function* addKeywords({ payload: { referralCategoryId, selectedUnassignedKeywords } }) {
  const { organization_id } = yield getBaseUrlParams();

  yield call(api.assignReferralCategory, {
    organization_id,
    id: referralCategoryId.toString(),
    clubready_referral_keyword_id: selectedUnassignedKeywords.map((el) => el.id)
  });

  yield put({
    type: ASSIGN_KEYWORDS_SUCCESS,
    payload: { referralCategoryId, selectedUnassignedKeywords }
  });
}

function* removeKeyword({ payload: { referralCategoryId, id, name, clientsCount } }) {
  const { organization_id } = yield getBaseUrlParams();

  yield call(api.unassignReferralCategoryKeyword, {
    organization_id,
    id: referralCategoryId.toString(),
    clubready_referral_keyword_id: id.toString()
  });

  yield put({
    type: UNASSIGN_KEYWORD_SUCCESS,
    payload: { referralCategoryId, id, name, clientsCount }
  });
}

function* removeAllKeywords({ payload }) {
  const { organization_id } = yield getBaseUrlParams();
  const currentReferralInfo = yield select((state) => state.referralCategories.currentReferralInfo);

  let referralInfo;

  if (currentReferralInfo == null || payload !== currentReferralInfo.id) {
    const { data } = yield call(api.getReferralCategory, payload, {
      params: { organization_id }
    });

    referralInfo = data;
  }

  yield call(api.unassignAllReferralCategoryKeywords, {
    organization_id,
    id: payload.toString()
  });

  yield put({
    type: UNASSIGN_ALL_KEYWORDS_SUCCESS,
    payload: { id: payload, referralInfo }
  });
}
